/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA1Icon16Light = forwardRef('DataChartPieA1Icon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 1a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .75.433l5.196-3a.5.5 0 0 0 .183-.683A6.5 6.5 0 0 0 7.5 1ZM8 6.634V2.023a5.5 5.5 0 0 1 3.993 2.305L8 6.634Z" }),
        React.createElement("path", { d: "M5.683 2.309a.5.5 0 0 0-.33-.944A6.5 6.5 0 1 0 13.91 6.42a.5.5 0 0 0-.986.166A5.5 5.5 0 1 1 5.683 2.31Z" })));
});
